import React from "react";
import TeamSection from "../../Components/TeamSection/TeamSection";
import sarai from "../../assets/Sarai.png";
import lemny from "../../assets/Lemny.png";
import playgrynd from "../../assets/Playgrynd.png";
import bitgallery from "../../assets/Bitgallery.png";
import defaultPic from "../../assets/placeholder.png";
import ai from "../../assets/AI.jpeg";

function TeamSectionPage(props) {
  return (
    <a href id="team">
      <div className="md:px-40 2xl:px-[280px] mt-10 py-20">
        <div className="flex flex-col  mb-10 md:flex-row">
          <div className="w-full px-10 md:px-0 lg:px-20">
            <h1 className=" pb-2 mt-5 tracking-tight font-bold letter-spacing:-0.05em text-transparent text-2xl md:text-3xl lg:text-5xl 2xl:text-[56px] bg-clip-text bg-gradient-to-r from-[#8926B6] to-[#EABCFF]">
              The Team
            </h1>
          </div>
          <div className="w-full px-10 md:px-10 lg:px-32">
            {" "}
            <p className="tracking-tight letter-spacing:-0.05em text-[#747397] mt-5 text-left md:text-lg lg:text-[18px]">
              We’ve got some great hands on the project. Amazing people united
              by a positive energy and an inspiration to serve.
            </p>
          </div>

          {/* <div className="w-11/12 px-10 pb-2 font-bold lg:pl-20 lg:px-10 md:px-0">
            <h1 className=" pb-2 mt-5 tracking-tight letter-spacing:-0.05em text-transparent text-2xl md:text-3xl lg:text-5xl 2xl:text-[56px] bg-clip-text bg-gradient-to-r from-[#8926B6] to-[#EABCFF]">
              The Team
            </h1>
          </div>
          <div className="w-2/3 pl-10 md:pl-[20px] md:ml-[-110px] md:w-6/12 xl:w-6/12 lg:ml-[-200px] lg:pr-[100px] 2xl:pr-[200px]">
            <p className="tracking-tight letter-spacing:-0.05em text-[#747397] mt-5 text-left md:text-lg lg:text-[18px]">
              We’ve got some great hands on the project. Amazing people united
              by a positive energy and an inspiration to serve.
            </p>
          </div> */}
        </div>

        <TeamSection
          name1={"PlayGrynd"}
          name2={"Ai"}
          subtitle1={"3D Artist / Creator"}
          subtitle2={"Product Manager / Creator"}
          picture1={playgrynd}
          picture2={ai}
          oneLink={true}
          linkTree={"Ai_dezign"}
          insta={true}
          instaLink1={"playgrynd"}
        />
        <TeamSection
          name1={"bitgallery"}
          subtitle1={"Developer"}
          picture1={bitgallery}
          twitter={true}
          twitterLink1={"bitgallery1"}
        />
      </div>
    </a>
  );
}

export default TeamSectionPage;
